// extracted by mini-css-extract-plugin
export default {"dashboardCard":"DashboardCard_dashboardCard__CtCO6 CardBase_cardBase__kod3x"};